import React, { useContext } from "react";
import {
    PortalMetricCard,
    PortalMetricGrid,
    PortalMetricLabel,
    PortalMetricValue,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalDescription,
    StandardModalHeading,
    StandardModalSection,
    StandardModalText
} from "src/components";
import { EmailCampaignsContext } from "../EmailCampaignsContext";

export default function EmailPro() {
    const {
        toggleEmailPackages,
        openPayment,
        packages,
        purchasedEmailPro,
        openDowngrade,
        pendingDowngrade
    } = useContext(EmailCampaignsContext);
    const currentAddon = purchasedEmailPro?.addon;
    const purchasedAddonUuid = purchasedEmailPro?.addonUuid || null;
    const currentPlan = packages.find(
        plan => plan.uuid === purchasedAddonUuid || (!purchasedAddonUuid && plan.price === 0)
    );
    const currentPrice = currentPlan?.price ?? 0;

    return (
        <StandardModalSection padding="2.5rem" border="0" borderRadius="0" background="transparent" gap="2rem">
            <div>
                <StandardModalHeading size="2rem" align="center">Send More. Reach More. Do More.</StandardModalHeading>
                <StandardModalDescription align="center" maxWidth="37rem">
                    Upgrade to Email Pro for higher monthly sends, no daily limits, and powerful automations.
                </StandardModalDescription>
            </div>

            <PortalMetricGrid columns="4" gap="1rem">
                {packages.map(plan => {
                    const isCurrent = purchasedAddonUuid === plan.uuid || (!purchasedAddonUuid && plan.price === 0);
                    const isDowngrade = plan.price < currentPrice;
                    const isPendingDowngrade = pendingDowngrade?.newAddonUuid === plan.uuid;
                    const priceLabel = plan.price === 0 ? "FREE" : `AUD $${plan.price} / year`;
                    const actionLabel = isPendingDowngrade
                        ? "Cancel Downgrade"
                        : isCurrent
                            ? "Current Plan"
                            : isDowngrade
                                ? "Downgrade"
                                : "Upgrade";

                    const handlePlanAction = () => {
                        if (isPendingDowngrade || isDowngrade) {
                            openDowngrade({ plan, currentAddon });
                        } else {
                            openPayment({ plan, currentAddon });
                        }
                    };

                    return (
                        <PortalMetricCard
                            key={plan.uuid}
                            minHeight="16rem"
                            border={isCurrent ? "2px solid var(--calendar-text, #171A22)" : undefined}
                        >
                            <PortalMetricLabel>Email Pro plan</PortalMetricLabel>
                            <PortalMetricValue size="1.75rem">{plan.title}</PortalMetricValue>
                            <StandardModalText weight="700" color="var(--calendar-text, #171A22)">
                                {priceLabel}
                            </StandardModalText>
                            {!isPendingDowngrade && (
                                <StandardModalText size="0.8125rem">{plan.description}</StandardModalText>
                            )}
                            <StandardModalText size="0.8125rem">
                                Includes {plan.includes.join(", ")} monthly sends and no daily limit.
                            </StandardModalText>
                            {isPendingDowngrade && (
                                <StandardModalText size="0.8125rem" color="var(--calendar-action-primary-bg, #5B6EF5)">
                                    Downgrade confirmed to {plan.title}. The change takes effect at your next renewal.
                                </StandardModalText>
                            )}
                            <StandardModalActionButton
                                type="button"
                                width="100%"
                                minWidth="0"
                                $variant={isCurrent ? undefined : "primary"}
                                disabled={isCurrent}
                                onClick={isCurrent ? undefined : handlePlanAction}
                            >
                                {actionLabel}
                            </StandardModalActionButton>
                        </PortalMetricCard>
                    );
                })}
            </PortalMetricGrid>

            <StandardModalText align="center">
                Your Email Pro upgrade will be added to your current Me Business subscription and billed on your existing monthly or yearly cycle.
            </StandardModalText>

            <StandardModalActionGroup $center>
                <StandardModalActionButton type="button" onClick={toggleEmailPackages}>
                    Cancel
                </StandardModalActionButton>
            </StandardModalActionGroup>
        </StandardModalSection>
    );
}
